export default "__VITE_ASSET__BVJ_13I8__"